export const iconFontAwesomeHumanitarianTemperatureArrowDown = (
	<i className="fa-solid fa-temperature-arrow-down"></i>
);
